module.exports = __webpack_public_path__ + "static/img/1_5_1.3c2bf969.jpg";